export const EXPORT_MODAL_CLOSE_BUTTON = 'close-modal-x'
export const EXPORT_MODAL_CANCEL_BUTTON = 'cancel-btn'
export const EXPORT_MODAL_SUBMIT_BUTTON = 'modal-export-btn'
export const EXPORT_MODAL_SELECT_DROPDOWN_EXPORT = 'export-select-dropdown'
export const EXPORT_MODAL_SELECT_DROPDOWN_MOVE = 'move-select-dropdown'
export const EXPORT_MODAL_TITLE = 'modal-title'
export const EXPORT_MODAL_TAB = (tab) => `tab-${tab}`
